export default __webpack_public_path__ + "static/media/sweet1.ea414e5b.jpg";